export const HEADERSTATUS = {
  MONTH: 'Month',
  YEAR: 'Year',
};
